// We need the A-frame library
import 'aframe';
import '@azure/storage-blob';

// import js scripts
import './js/aframe-event-set-component.min.js';
import './js/aframe-layout-component.min.js';
import './js/aframe-template-component.min.js';
import './js/click-button.js';
import './js/entry-manager.js';
import './js/final-choise-button.js';
import './js/global-variables-adidas-webvr.js';
import './js/go-to-home-page.js';
import './js/play-video.js';
import './js/scene-controller.js';
import './js/swap-image.js';
import './js/translate-object.js';
import './js/admin-controller.js';
import './js/video180.js';

// Actual code for the application
function activate() {
};

document.addEventListener('DOMContentLoaded', activate);
